/*
  hm-gang-active — keep the gallery's "current slide" and the colour filter
  agreeing with each other.  (Igor 2026-09-13)

  THE PROBLEM, measured on the deployed preview.

  The product gallery has TWO independent ideas of which media shows:

    .is-active     the slider's current slide
    .gang__active  the colour filter, driven by the #color_<value> alt suffix

  A server-rendered load is fine: the same item carries both. But after a
  visitor clicks a colour swatch, the theme's own updateGangMedia() moves
  .gang__active onto the new colour's media and leaves .is-active where it was.
  It only reconciles the two for <product-gallery>, and only when the variant
  has NO featured_media (assets/global.js, the `if (!this.currentVariant
  .featured_media)` branch). Our carrier variants DO have featured media, so
  that branch never runs.

  Result measured after clicking Black: 5 items .gang__active, .is-active on a
  colour-neutral item that is not among them, every media item computing
  display:none, and the gallery box collapsed to 650x101. An empty product
  image. It settles roughly 3.3s after the click, because a late section
  re-render puts the stale .is-active back.

  THE FIX is deliberately a RECONCILER rather than a patch to updateGangMedia:
  the thing that breaks it is a re-render that lands AFTER that function has
  run, so a one-shot fix in the same call stack would be undone. This watches
  and repairs, which survives whatever re-renders and in whatever order.

  It only ever acts when the two disagree, so it is a no-op on a healthy page
  and on any product with no gang alts at all.
*/
(function () {
  'use strict';

  function reconcile(gallery) {
    // Only galleries that actually use the colour filter.
    var gangItems = gallery.querySelectorAll('.product__media-item[data-gang-connect]');
    if (!gangItems.length) return false;

    var active = gallery.querySelectorAll('.product__media-item.gang__active');
    if (!active.length) return false;                 // mid-swap, leave it alone

    // Already agreeing? Then there is nothing to do, and doing nothing matters:
    // moving .is-active on a healthy page would fight the slider.
    if (gallery.querySelector('.product__media-item.gang__active.is-active')) return false;

    var stale = gallery.querySelectorAll('.product__media-item.is-active');
    for (var i = 0; i < stale.length; i++) stale[i].classList.remove('is-active');
    active[0].classList.add('is-active');
    return true;
  }

  function run() {
    var galleries = document.querySelectorAll('media-gallery, product-gallery');
    var fixed = 0;
    for (var i = 0; i < galleries.length; i++) {
      if (reconcile(galleries[i])) fixed++;
    }
    return fixed;
  }

  var pending = null;
  function schedule() {
    if (pending) return;                              // debounce a burst of mutations
    pending = setTimeout(function () { pending = null; run(); }, 60);
  }

  function start() {
    run();

    // The section re-renders on a variant change, so watch for the classes
    // moving and for the gallery being replaced wholesale.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(schedule);
      var section = document.querySelector('[id^="shopify-section-"] media-gallery, [id^="shopify-section-"] product-gallery');
      var target = section ? section.closest('[id^="shopify-section-"]') : document.body;
      mo.observe(target, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    }

    // Belt and braces for the late re-render measured at ~3.3s.
    [300, 1000, 2000, 3500, 5000].forEach(function (t) { setTimeout(run, t); });
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
